const appConstants = {
    localStorageKeyFontSize: "app-fontSize",
    localStorageKeyTheme: "app-theme",
    localStorageKeyLastPath: "lastPath",
    localStorageKeyPositionY: "positionY",
    localStorageDataPrefix: "rwd_data_",
    localStorageMetaPrefix: "rwd_meta_",
    localStorageKeyTrustyHighScore: "trusty_hs_global",
    scenarioItemTypeVocabulary: "vocabulary",
    apiBaseUrl: 'https://ak-2014-marsupial.github.io/rwd/data',
    apiManifestUrl: 'https://ak-2014-marsupial.github.io/rwd/data/version.json',
    indexRouterDomPath: "/test",
    availableThemes: ["light", "dark"],
    fontSizeMin: 14,
    fontSizeMax: 18,
    fontSizeStep: 1,
    headerHeight: "10vh",
    positionYMin: 20,
    positionYUpdateThreshold: 10

}

export {appConstants}